import { CustomDateObject, Member } from '../shared/types'
import getDateFromCustomDate from '../util/getDateFromCustomDate'

const getAgeOfMemberAtDate = (member: Member, customDate: CustomDateObject) => {
  const date = getDateFromCustomDate(customDate)
  const memberBirthday = getDateFromCustomDate(member.birthday)
  if (date && memberBirthday) {
    const diffMs = date?.getTime() - memberBirthday?.getTime()
    const ageMs = new Date(diffMs)
    const ageYears = ageMs.getUTCFullYear() - 1970
    return ageYears
  }
}

export default getAgeOfMemberAtDate
